import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { Address, BankReference, InputDataForForm, Lang, LegalFormReference, Organization, OrganizationRoleReference, ReferenceParams, Res, VatPayerReference } from 'src/app/models';
import { LanguageService, ApiOrganizationsService, ValidatorsService, ApiBanksService, DatetimeService, FilesService } from 'src/app/services';
import { OrganizationBasicValidator } from './organization-basic.validator';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadProcessComponent } from 'src/app/components/dialog';

@Component({
  selector: 'app-organization-basic',
  templateUrl: './organization-basic.component.html',
  styleUrls: ['./organization-basic.component.css']
})
export class OrganizationBasicComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;

  orgName: Lang;
  orgId: string;
  legalForms: LegalFormReference[];
  oroles: OrganizationRoleReference[];
  banks: BankReference[];
  vatPayers: VatPayerReference[];
  structuralLevels: any[];
  errorMessages: any;
  multiple: boolean = true;
  logo: any;
  background: any;
  ffInputLang: any = { name: '', valid: false };
  ffInputLangParams = {
    name: {
      clearField: true,
      required: true
    }
  }

  form: UntypedFormGroup = this.fb.group({
    id: [null],
    ident_num: [null, this.validator.ident_num],
    legal_form_id: [null],
    structural_level_id: [{ value: 'HEADE_OFFICE', disabled: true }],
    orole_id: [null],
    name: [null],
    logo_pic: [null],
    background_pic: [null],
    addresses: this.fb.array([]),
    banks: this.fb.array([]),
    vat_payer: this.fb.group({
      id: [null],
      vat_payer_id: [null],
      seria: [null],
      number: [null],
      date: [null],
    })
  });

  @Input() set inputDataForForm(answer: InputDataForForm) {

    if (!answer) return;

    if (answer.action == 'create' || answer.action == 'update') {

      this.resetForm();
    }

    if (answer.action == 'edit') {

      this.resetForm();
      this.setDataInForm(answer.value);
    }
  }

  @Output() changeFormEvent = new EventEmitter();

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private apiOrganizations: ApiOrganizationsService,
    private apiBanks: ApiBanksService,
    private datetimeService: DatetimeService,
    private validator: OrganizationBasicValidator,
    private validatorService: ValidatorsService,
    private NgbModal: NgbModal,
    private fileService: FilesService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.getLegalForm();
    this.getRoles();
    this.getBanks();
    this.getVatPayers();
    this.getStructuralLevel();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );

    this.subscriptions.add(

      this.form.valueChanges.subscribe(value => {

        if (value) {

          this.changeFormEvent.emit({
            form: value,
            valid: this.form.valid, // тут учесть валидацию поля ff-input-lang
            langValid: this.ffInputLang.valid
          });
        }

      })
    );

    this.addAddressField('legal');
    this.addAddressField('actual');
    this.addBankAccountField();
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   * @param fieldName string
   * @param value Lang
   */
  eventFnFF(fieldName: string, value: any): void {

    this.ffInputLang = value;

    this.form.controls[fieldName].setValue(value.name);
  }


  /**
   * 
   */
  getLegalForm(): void {

    let params: ReferenceParams = {
      ref_name: 'legal_forms'
    }

    this.subscriptions.add(

      this.apiOrganizations.getReferences(params, params.ref_name).subscribe((response: Res) => {

        if (response != null) {

          this.legalForms = response.result;
        }
      })
    );
  }


  /**
   * 
   */
  getRoles(): void {

    let params: ReferenceParams = {
      ref_name: 'oroles'
    }

    this.subscriptions.add(
      this.apiOrganizations.getReferences(params, params.ref_name).subscribe((response: Res) => {

        if (response != null) {

          this.oroles = response.result;
        }
      })
    );
  }


  /**
   * 
   */
  getVatPayers(): void {

    let params: ReferenceParams = {
      ref_name: 'vat_payers'
    }

    this.subscriptions.add(
      this.apiOrganizations.getReferences(params, params.ref_name).subscribe((response: Res) => {
        console.log('[RESPONSE] getVatPayers: ', response);

        if (response != null) {

          this.vatPayers = response.result;
        }
      })
    );
  }


  /**
   * 
   */
  getBanks(): void {

    let params: ReferenceParams = {
      ref_name: 'banks'
    }

    this.subscriptions.add(
      this.apiBanks.getReferences(params, params.ref_name).subscribe((response: Res) => {

        if (response != null) {

          this.banks = response.result;
        }
      })
    );
  }


  /**
   * 
   */
  getStructuralLevel(): void {

    this.structuralLevels = [
      {
        id: 'BRANCH',
        name: 'Филиал'
      },
      {
        id: 'HEADE_OFFICE',
        name: 'Головной офис'
      }
    ];
  }


  /**
   * 
   * @param type string
   */
  initAddressField(type: string = ''): any {

    return this.fb.group({
      id: [''],
      locality: [null],
      street: [null],
      home: [null],
      index: [null],
      address_type: [type]
    });
  }


  /**
   * 
   * @param type string
   */
  addAddressField(type: string = ''): void {

    let control = this.form.controls.addresses as UntypedFormArray;
    control.push(this.initAddressField(type));
  }


  /**
   * 
   * @param i number
   */
  removeAddressField(i: number): void {

    let control = this.form.controls.addresses as UntypedFormArray;
    control.removeAt(i);
  }


  /**
   * 
   * @param address Address
   */
  setDataInAddressField(address: Address): any {

    return this.fb.group({
      id: address.id,
      locality: address.locality,
      street: address.street,
      home: address.home,
      index: address.index,
      address_type: address.address_type
    });
  }


  /**
   * 
   * @param address Address
   */
  addAddressFieldWithData(address: Address): void {

    let control = this.form.controls.addresses as UntypedFormArray;
    control.push(this.setDataInAddressField(address));
  }


  /**
   *
   */
  initBankAccountField(): any {

    return this.fb.group({
      id: [''],
      bank_id: [null],
      bic: [{ value: null, disabled: true }],
      account: [null]
    });
  }


  /**
   *
   */
  addBankAccountField(): void {

    let control = this.form.controls.banks as UntypedFormArray;
    control.push(this.initBankAccountField());

    let index: number = (this.form.get('banks').value.length - 1);

    if (index > -1) {

      this.subscriptions.add(
        this.form.get(['banks', index, 'bank_id']).valueChanges.subscribe(value => {

          if (value) {

            let bankIndex = this.banks.findIndex(val => val.id == value);

            if (bankIndex > -1) {

              this.form.get(['banks', index, 'bic']).setValue(this.banks[bankIndex].bic);
            }
          }
        })
      );
    }
  }


  /**
   * 
   * @param i number
   */
  removeBankAccountField(i: number): void {

    let control = this.form.controls.banks as UntypedFormArray;
    control.removeAt(i);
  }


  /**
   * 
   * @param bankAccount any
   * @returns any
   */
  setDataInBankAccountField(bankAccount: any): any {

    return this.fb.group({
      id: [bankAccount.id],
      bank_id: [bankAccount.bank_id],
      bic: [{ value: bankAccount.bic, disabled: true }],
      account: [bankAccount.account]
    });
  }


  /**
   * 
   * @param bankAccount any
   */
  addBankAccountFieldWithData(bankAccount: any): void {

    let control = this.form.controls.banks as UntypedFormArray;
    control.push(this.setDataInBankAccountField(bankAccount));
  }


  /**
   * 
   * @param organization Organization
   */
  setDataInForm(organization: Organization): void {

    if (!organization) return;

    if(organization.addresses != null) organization.addresses = this.apiOrganizations.sortAddress(organization.addresses);

    this.orgName = organization.name;

    this.form.controls.id.setValue(organization.id);
    this.form.controls.ident_num.setValue(organization.ident_num);
    this.form.controls.legal_form_id.setValue(organization.legal_form_id);
    this.form.controls.structural_level_id.setValue('HEADE_OFFICE');
    this.form.controls.orole_id.setValue(organization.orole_id);
    this.form.controls.logo_pic.setValue(organization.logo_pic);
    this.form.controls.background_pic.setValue(organization.background_pic);

    this.getImageContent(organization);

    if (organization.addresses != null) {

      for (let address of organization.addresses) {

        this.addAddressFieldWithData(address);
      }
    }
    else {

      this.addAddressField('legal');
      this.addAddressField('actual');
    }

    if (organization.banks != null) {

      for (let bankAccont of organization.banks) {


        this.addBankAccountFieldWithData(bankAccont);
      }
    }
    else {

      this.addBankAccountField();
    }

    if (organization.vat_payer != null) {

      if (organization.vat_payer.date) {

        let vatPayers = { ...organization.vat_payer };

        vatPayers.date = this.datetimeService.convertDateForDatepicker(<string>organization.vat_payer.date);

        this.form.get('vat_payer').setValue(vatPayers);
      }
    }
  }


  /**
   * 
   */
  resetForm(): void {

    let addresses: any[] = this.form.get('addresses').value;
    let banks: any[] = this.form.get('banks').value;

    for (let item of addresses) {

      this.removeAddressField(0);
    }

    for (let item of banks) {

      this.removeBankAccountField(0);
    }

    this.form.reset();
    this.orgName = null;
  }

  /** UPLOAD FILES VER №1 */
  /**
   * 
   * @param event 
   */
  uploadedFile(event, type: string): void {

    console.log("EVENT: ", event);

    if (type == 'logo') {

      this.form.controls.logo_pic.setValue(event.result.id);
      event.result['logo_pic'] = event.result.id;
      this.getImageContent(event.result);

    } else {

      this.form.controls.background_pic.setValue(event.result.id);
      event.result['background_pic'] = event.result.id;
      this.getImageContent(event.result);
    }

  }

  /**
   * 
   * @param product Product
   */
  getImageContent(organization: any): void {

    if (organization.logo_pic && organization.logo_pic != null) {

      this.subscriptions.add(
        this.fileService.getImageContent(organization.logo_pic).subscribe((response: any) => {

          if (response != null) {

            this.logo = response.result;

          }
        })
      );
    }
    if (organization.background_pic && organization.background_pic != null) {

      this.subscriptions.add(
        this.fileService.getImageContent(organization.background_pic).subscribe((response: any) => {

          if (response != null) {

            this.background = response.result;
          }
        })
      );
    }
  }

  /**
  * 
  * @param ids 
  */
  onDeleteFiles(type: string): void {

    type == 'logo' ? this.form.controls.logo_pic.setValue(null) : this.form.controls.background_pic.setValue(null)

  }


  /**
  * 
  * @param field 
  * @param type 
  */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }



}
